let a;
export default url => {
	if (!a) {
		a = document.createElement("a");
	}
	a.href = url;
	return a.href;
};
